import type { FC, SVGProps } from 'react'

export const VolumeLevelOne: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0656 5.24521C12.0656 4.37304 11.0567 3.88815 10.3757 4.43299L7.12356 7.03469H4.21007C3.63561 7.03469 3.16992 7.50038 3.16992 8.07484V11.925C3.16992 12.4995 3.63561 12.9651 4.21007 12.9651H7.12356L10.3757 15.5668C11.0567 16.1117 12.0656 15.6268 12.0656 14.7546V5.24521Z"
      stroke="currentColor"
      strokeOpacity="0.7"
      strokeWidth="1.15572"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.553 6.50092C16.4795 7.42769 17 8.68449 17 9.99494C17 11.3054 16.4795 12.5622 15.553 13.489"
      stroke="currentColor"
      strokeOpacity="0.7"
      strokeWidth="1.15572"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
